import React from 'react';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../../common/Forms/FormTextField';
import { useDispatch } from 'react-redux';
import { setComments } from '../../../../../../redux/organization/organizationTabs/organizationComments/organizationCommentsSlice';

const CommentsForm = (props) => {
  const { control, register, errors } = props;
  const dispatch = useDispatch();

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12}>
          <FormInputText
            name='comment'
            type='text'
            control={control}
            multiline={true}
            rows={8}
            errors={!!errors.comment}
            helperText={errors?.comment?.message}
            label='Comments'
            register={register('comment', {
              onChange: (e) => dispatch(setComments(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CommentsForm;
